export default __webpack_public_path__ + "static/media/bird-AI_2.75070813.png";